import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context';
import { PlanDrawerProvider } from './context/PlanDrawerContext';
import 'react-modern-drawer/dist/index.css';
import './i18n/config';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div></div>}>
      <AuthProvider>
        <PlanDrawerProvider>
          <App />
        </PlanDrawerProvider>
      </AuthProvider>
    </Suspense>
  </React.StrictMode>
);
reportWebVitals();
